// Primary brand colors - Nucleus Theme
export const colors = {
  // Core brand colors
  primary: '#262b45',    // Dark navy blue - main brand color
  secondary: '#ffffff',  // White - secondary brand color

  // Semantic color mappings
  brand: {
    primary: '#262b45',
    secondary: '#ffffff',
    accent: '#4f46e5',   // Indigo accent for highlights
    muted: '#6b7280',    // Gray for muted text
  },

  // Text colors based on brand colors
  text: {
    primary: '#ffffff',           // White text (on primary backgrounds)
    secondary: '#262b45',         // Dark text (on light backgrounds)
    light: 'rgba(255, 255, 255, 0.7)',  // Light text with opacity
    dark: 'rgba(38, 43, 69, 0.7)',      // Dark text with opacity
    muted: '#6b7280',            // Muted gray text
    accent: '#4f46e5',           // Accent text color
  },

  // Background colors
  background: {
    primary: '#262b45',          // Primary dark background
    secondary: '#ffffff',        // Secondary light background
    light: '#f8fafc',           // Very light background
    gray: '#f1f5f9',            // Light gray background
    card: '#ffffff',            // Card backgrounds
    overlay: 'rgba(38, 43, 69, 0.8)', // Modal/overlay backgrounds
  },

  // Border colors
  border: {
    primary: '#262b45',                    // Primary border
    secondary: '#e2e8f0',                  // Light border
    light: 'rgba(255, 255, 255, 0.12)',   // Light border with opacity
    dark: 'rgba(38, 43, 69, 0.12)',       // Dark border with opacity
    muted: '#cbd5e1',                     // Muted border
    focus: '#4f46e5',                     // Focus states
  },

  // Interactive states
  interactive: {
    hover: {
      primary: 'rgba(38, 43, 69, 0.9)',     // Primary hover
      secondary: 'rgba(255, 255, 255, 0.9)', // Secondary hover
      light: 'rgba(38, 43, 69, 0.05)',      // Light hover
    },
    active: {
      primary: 'rgba(38, 43, 69, 0.95)',    // Primary active
      secondary: 'rgba(255, 255, 255, 0.8)', // Secondary active
    },
    disabled: {
      primary: 'rgba(38, 43, 69, 0.4)',     // Disabled primary
      secondary: 'rgba(255, 255, 255, 0.4)', // Disabled secondary
      text: 'rgba(107, 114, 128, 0.5)',     // Disabled text
    },
  },

  // Status colors
  status: {
    success: '#10b981',    // Green
    error: '#ef4444',      // Red
    warning: '#f59e0b',    // Amber
    info: '#3b82f6',       // Blue
    // With opacity variants
    successLight: 'rgba(16, 185, 129, 0.1)',
    errorLight: 'rgba(239, 68, 68, 0.1)',
    warningLight: 'rgba(245, 158, 11, 0.1)',
    infoLight: 'rgba(59, 130, 246, 0.1)',
  },

  // Shadow colors
  shadow: {
    light: 'rgba(0, 0, 0, 0.1)',
    medium: 'rgba(0, 0, 0, 0.15)',
    dark: 'rgba(0, 0, 0, 0.25)',
    primary: 'rgba(38, 43, 69, 0.15)',
  },
} as const;

export type Colors = typeof colors;
